angular.module('dealerware.web.data').factory('DealerwareVehicleCollection', function (
    $http, Collection, $dealerwareSearchAliases
) {

    'use strict';

    var baseEndpoint = '/locations/:location_id/cars';

    function useSolrSearch (params) {

        return $dealerwareSearchAliases.getAlias (
                params && params.filter && params.filter.states
            ) !== 'all' && ! params.isCsvExport;
    }

    var collection = new Collection({
        baseEndpoint: baseEndpoint,
        actionOverrides: undefined,
        customActions: {
            solr_search: {
                endpoint: baseEndpoint + '/search',
                method: 'GET',
                ignoreDefaultRootNodeRequest: true,
                ignoreDefaultAssociationMapper: true
            },
            solr_search_with_filters: {
                endpoint: function(endpoint, args) {
                    return useSolrSearch(args.params) ? baseEndpoint + '/solr_search/full' : baseEndpoint;
                },
                method: 'GET',
                ignoreDefaultRootNodeRequest: true,
                ignoreDefaultAssociationMapper: true
            },
            vehicles_not_under_contract: {
                endpoint: '/locations/:location_id/cars_not_under_contract',
                method: 'GET',
                ignoreDefaultAssociationMapper: true
            },
            cars_in_inventory: {
                endpoint: '/locations/:location_id/cars_in_inventory',
                method: 'GET'
            },
            inventory: {
                endpoint: '/locations/:location_id/reports/inventory',
                rootNode: 'vehicle_inventory_report_items',
                method: 'GET',
                ignoreDefaultAssociationMapper: true
            },
            utilization: {
                endpoint: '/locations/:location_id/reports/utilization',
                rootNode: 'utilization_report_items',
                method: 'GET',
                ignoreDefaultAssociationMapper: true
            }
        },
        params: {
            include_location: true
        },
        responseFormatter: undefined,
        associationMapper:undefined,
        rootNode: 'cars',
        rootNodeResponse: undefined,
        rootNodeRequest: undefined,

        requestTransforms: new function() {

            this.solr_search_with_filters = function(args, data, params) {

                if (! useSolrSearch (params)) {
                    delete params.filter;
                }
            };
        },

        responseTransforms: {
            all: function(data) {
                data.forEach(function(record) {
                    if (record.data.mileage) {
                        record.data.mileage = parseFloat(record.data.mileage).toFixed();
                    }

                    if (record.data.connected && record.data.last_connected_car_scan) {
                        record.data.firmware_version = record.data.last_connected_car_scan.firmware_version || '';
                    }
                });
            },

            solr_search: function(args, data) {
                this.all(data);
            },

            solr_search_with_filters: function(args, data) {
                this.all(data);
            },

            vehicles_not_under_contract: function(args, data) {
                this.all(data);
            }
        },
        model: 'DealerwareVehicleModel'
    });

    jQuery.extend(collection.prototype, { });

    return collection;
});